import "antd/lib/dropdown/style";
import Dropdown from "antd/lib/dropdown";

export default Dropdown;
